import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { loginSuccess, logout } from '../slices/authSlice';
import { selectAuth } from '../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'



export const postData = createAsyncThunk(
  "type/postData",
  async (data) => {
    try {
      const response = await axios.post("https://reqres.in/api/users", data);
      // If you want to get something back
      return response.data;
    } catch (err) {
      console.error(err)
    }
  }
);

export const logoutRequest = createAsyncThunk(
  "type/postData",
  async () => {
    const { isAuthenticated, userInformation } = useSelector(selectAuth);
    const dispatch = useDispatch()
    try {
      const response = await axios.post("/api/logout");
      if (response.status === 200) {
        dispatch(logout())
        console.log("batata")
        return response.data;
      }
      console.log("kabis" + response)
      return { message: 'Error' };
    } catch (err) {
      console.error(err)
    }
  }
);